import React from 'react';
import useLocationQuery from '../../../hooks/useQuery';
import { HeaderWithFilter, IconWrapper } from '../../../healtheraComponents';
import { ORDER_BY } from '../constants';
import { isFilteredByRagStatus } from '../helpers';

const TimeslotHeader = () => {
  const { query, changeLocationQuery } = useLocationQuery();

  const timeslotFilterClickHandler = () => {
    if (isFilteredByRagStatus(query)) {
      const { order_by, ...newQuery } = query;
      changeLocationQuery({
        ...newQuery,
        page: 0,
      });
    } else {
      changeLocationQuery({
        ...query,
        order_by: ORDER_BY.RAG_STATUS,
        page: 0,
      });
    }
  };

  return (
    <HeaderWithFilter onClick={timeslotFilterClickHandler}>
      <div>Timeslot / Recommended by</div>
      <IconWrapper open={isFilteredByRagStatus(query)} />
    </HeaderWithFilter>
  );
};

export default TimeslotHeader;
